import { Card, Table, TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow, DateDisplay } from 'app/components';
import clsx from 'clsx';
import React from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },
  table: {
    padding: 0,
  },
}));

const RegtankInfoTable = (props) => {
  const { info = {}, session = {}, className } = props;
  const classes = useStyles();

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>Verification Details</TitleField>
      <Table className={classes.table}>
        <TableBody>
          <DataRow name="Request ID" value={info.requestId} />

          <DataRow name="Name" value={info.target_name} />
          <DataRow name="Email" value={info.target_email} />

          <DataRow name="Created Date" value={<DateDisplay date={info.createdDate} />} />

          <DataRow name="Verified Date" value={<DateDisplay date={info.verifyDate} />} />

          <DataRow name="Completed Date" value={<DateDisplay date={info.completedDate} />} />

          <DataRow name="Last Updated" value={<DateDisplay date={info.updatedDate} />} />
          <DataRow name="Device Type" value={session.deviceType || '-'} />

          <DataRow name="IP Address" value={session.requestIpAddress || '-'} />
        </TableBody>
      </Table>
    </Card>
  );
};

export default RegtankInfoTable;
